require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./liste-denseignants-2-0-3.json") })
        }
      }, "path---liste-denseignants-2-0-3");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---liste-denseignants-2-0-3!./.cache/json/liste-denseignants-2-0-3.json
// module id = 481
// module chunks = 231608221292675